import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireDatabase } from 'angularfire2/database';
import { isNil } from 'lodash';

/** This item will be responsible for rendering report summaries */
@Component({
  selector: 'report-summary-item',
  templateUrl: 'report-summary-item.html'
})
export class ReportSummaryItemComponent {

  /** Whether to show a spinner or not */
  @Input() loading: boolean;

  @Input() report: seafrozen.IReportSummary;

  public supplierName$: Observable<string>;

  public authorImage$: Observable<string>;

  constructor(private db: AngularFireDatabase) { }

  ngOnInit() {
    this.supplierName$ = this.db.object(`/suppliers/${this.report.reportSummary.supplierId}/name`)
      .filter( wrappedValue => !isNil(wrappedValue.$value) )
      .map( wrappedValue => wrappedValue.$value );

    this.authorImage$ = this.db.object(`/admins/${this.report.reportSummary.authorId}/profileImage`)
      .filter(wrappedValue => !isNil(wrappedValue.$value))
      .map(wrappedValue => wrappedValue.$value);
  }
}



// WEBPACK FOOTER //
// ./src/components/report-summary-item/report-summary-item.ts